/* Copyright (C) mroads, LLC - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Premsagar Choudhary <premsagar.choudhary@mroads.com>, Oct 2021
 * @flow
 */

import React from 'react';
import PropTypes from 'prop-types';
import Button from '../../../../components/Button';
import styles from './SensorSelection.module.css';
import strings from '../../../../globalization';

const SensorSelection = ({ navigateToSensor, dismissPopup }) => {
  return (
    <div className={styles.container}>
      <span className={styles.close} onClick={dismissPopup}>X</span>
      <span className={styles.title}>{strings.pleaseMakeASelection}</span>
      <div className={styles.buttonWrapper}>
        <Button className={styles.button} onClick={() => navigateToSensor('table')}>
          <span className={styles.buttonText}>{strings.tableSensor}</span>
        </Button>
        <Button className={styles.button} onClick={() => navigateToSensor('named')}>
          <span className={styles.buttonText}>{strings.namedSensor}</span>
        </Button>
      </div>
    </div>
  );
};

export default SensorSelection;

SensorSelection.propTypes = {
  navigateToSensor: PropTypes.func.isRequired,
  dismissPopup: PropTypes.func.isRequired,
};

SensorSelection.defaultProps = {
  navigateToSensor: () => { },
  dismissPopup: () => { },
};
